import { environment } from '../../../../environments/environment';
import { ResponseColumnsPackageV1, ResponseColumnsPackageV2 } from './view.model';
import { ReviewColumnsPackage } from './review.model';
// control to convert api get data to table
export class ViewPackageControl {
  /**
   * @arg dataSource the table data to show the received asi capabilities
   */
  dataSource: Array<object>;
  /**
  * @arg apiRequest to store parsed products payload
  */
  apiRequest: Array<object>;
  /**
   * @arg apiData the api response for the asi capabilities to be converted
   */
  apiData: Array<object>;
  /**
   *@arg responseColumnsPackage
   **/
  public responseColumnsPackage: string[];
  constructor(private activePortal: string) {
    this.dataSource = [];
    this.apiRequest = [];
    this.responseColumnsPackage = this.activePortal === 'svppv2' ? ResponseColumnsPackageV2 : ResponseColumnsPackageV1;
  }
  /**
   * @method getApiEndpoint returns the end point to call the asi capabilities
   */
  public get getApiEndpoint(): string {
    return environment.ProductCatalog.apis.getPackage;
  }
  /**
  * @method getReviewApiEndpoint returns the end point to call the product api
  */
  public get getReviewApiEndpoint(): string {
    return environment.ProductCatalog.apis.approveProduct;
  }
  /**
   * @method getParams returns the params for the api call
   * @arg state state of the records submitted or approved
   */
  public getParams(state: string): object {
    return state === 'submitted' ?
      { type: 'getpackage', params: { review: state } } : { type: 'getpackage' };
  }
  /**
   * @method setData sets the data and starts to parse the data
   */
  public setData(data: Array<object>): void {
    this.apiData = data;
    this.ParseData();
  }
  /**
   * @method ParseData parses the data to table data source
   */
  private ParseData(): void {
    this.apiData.forEach(product => {
      this.convertToDataSource(product);
    });
  }
  /**
   * @method convertToDataSource converts each record and makes it linear json
   * @arg product each product record
   */
  private convertToDataSource(product: object): void {
    this.dataSource.push(Object.assign(this.getFixedValues(product)));
  }
  /**
   * @method getFixedValues returns the fixed columns values from the product record
   * @arg product product record
   */
  private getFixedValues(product): object {
    const parsedData = {};
    this.responseColumnsPackage.forEach(key => {
      parsedData[key] = product[key];
      Object.assign(parsedData, { select: 'checkbox' });
    });
    return parsedData;
  }
  /**
   * @method getTableData returns the table data source
   */
  getTableData(): Array<object> {
    return this.dataSource;
  }
  /**
  * @method getColumns returns the column names
  **/
  public getColumns(reviewApproved: boolean): Array<string> {
    if (!this.responseColumnsPackage.includes('select')) { this.responseColumnsPackage.unshift('select'); }
    if (reviewApproved) { this.responseColumnsPackage.shift(); }
    return [...this.responseColumnsPackage];
  }
  /**
  * @method getApiRequest returns the api request
  * @arg reviewAction should contains the approval or rejected related flag as string
  * @arg selections should contains the selected product details.
  * @returns apiRequest should contains all the prased products ID and status as an object[]
  **/
  public getApiRequest(reviewAction: string, selections: Array<object>): object[] {
    this.apiRequest = [];
    selections.forEach(item => {
      this.apiRequest.push(this.getProductID(reviewAction, item));
    });
    return this.apiRequest;
  }
  /**
   * @method getProductID parse the fixed product ID's from the products record
   * @arg reviewAction should contains the approval or rejected related flag as string
   * @arg item  should contains a prodct as an object
   * @returns parsedData contains the parsed product ID and status as an object
   */
  private getProductID(reviewAction: string, item: object): object {
    const parsedData = {};
    ReviewColumnsPackage.forEach(key => {
      parsedData[key] = key === 'productID' ? item['productID'] : reviewAction;
    });
    return parsedData;
  }
  /**
   * @method getApitype returns api type
   * @returns object
   **/
  public get getApiType(): object {
    return { type: 'approve-package' };
  }
}
